import { render } from "./DroneImageAnalyzerIcon.vue?vue&type=template&id=54971070"
import script from "./DroneImageAnalyzerIcon.vue?vue&type=script&lang=js"
export * from "./DroneImageAnalyzerIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__